import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { checkBoxChange, DataStateChangeEventArgs, FilterSettingsModel, GridComponent, PageSettingsModel, SelectionSettingsModel } from '@syncfusion/ej2-angular-grids';
import { GlobalComponent } from 'src/app/global/global.component';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { columnWidth } from '../employee/employee.model';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { DateService } from 'src/app/date.service';
import { IMyDateModel, IMyDpOptions, IMyInputFieldChanged } from 'mydatepicker';
import { DatePipe } from '@angular/common';
import { functionpermission, GetReferalListBo, ReferralBo, ReferralClientRejectBO, WhereCondition } from './referral.modal';
import { ReferralServices } from './referral.service';
import { EventsServices } from '../events/events.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CommonApiService } from 'src/app/commonapiservice';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { GeneralService } from 'src/app/service/general.service';
import { AssignCareCoordinator, AssignCaseManager, carecoordinate, CareCoordinatorInfoLst, ClientCaseManagerRelationshipBO, ClientCoordinatorRelationshipBO, GetClientCarecoordinator  , GetClientCasemanager, getMappedCMDataBO } from '../client-parent/client-parent.model';
import { ClientCreateEditCareService } from '../client-parent/client-create-edit/client-create-editcare.service';
import { ClientEmployeeContactBO } from '../client-employee-contact/client-employee-contact.model';

@Component({
  selector: 'app-referral',
  templateUrl: './referral.component.html',
  styleUrls: ['./referral.component.scss']
})
export class ReferralComponent implements OnInit {
  @ViewChild('gridProspective') public gridProspective: GridComponent;
  @ViewChild("pdfIntakeformList") pdfIntakeformList;
  private onDestroy$: Subject<void> = new Subject<void>();
  rejectedItems: ReferralClientRejectBO = new ReferralClientRejectBO();
  public formatOptions: object;
  public formatOptions1: object;
  public statusList = [];
  public referralAge = 'UNDER'
  stateList: any = [];
  referralstartDate: string;
  referralendDate: string;
  ProspectiveCreate: boolean = false;
  ClientIntakeCreate: boolean = false;
  ProspectiveList: any = [];
  isApprovedRejectedFields: boolean = false;
  isViewApproveRejected: boolean = true;
  isIntakeBoolean: boolean = false;
  ColumnArray: columnWidth[];
  type: string = "";
  ValidationDate: any;
  id: string = "00000000-0000-0000-0000-000000000000";
  initialPage: PageSettingsModel;
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  public filterSettings: object;
  ReferralStatusLid: any;
  genderList: any;
  conditionlist: WhereCondition[] = [];
  today = new Date();
  arraycol: any = [];
  public GridDataReferral: Observable<DataStateChangeEventArgs>;
  locationId: string = "00000000-0000-0000-0000-000000000000";
  intakeEmail: boolean = false
  filterOptions: FilterSettingsModel;
  RBO: GetReferalListBo = new GetReferalListBo();
  public Prospectivedata: Observable<DataStateChangeEventArgs>;
  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'mm/dd/yyyy',
    showClearDateBtn: true,
    editableDateField: true
  };

  public myDatePickerOptionsDOB: IMyDpOptions = {
    dateFormat: 'mm/dd/yyyy',
    disableSince: { year: this.today.getFullYear(), month: this.today.getMonth() + 1, day: this.today.getDate() + 1 },
    showClearDateBtn: true,
    editableDateField: true
  };
  ReferralForm: FormGroup;
  AddressGoogleMap: boolean = false;
  @Input() GoogleMapList: any;
  @Output() GoogleMapEmit = new EventEmitter<any>();
  saveBo: ReferralBo = new ReferralBo();
  clientName: string = '';
  languageList: any = [];
  selectedLanguages: any = [];
  TypeofWaiver: any;
  cfssModel = ['AGENCY', 'BUDGET'];
  PaySourceitem: any = [];
  TypeofClient: any = [];
  genderfields: any;
  languagefields : any;
  waiverfield : any;
  paysourcfield : any;
  locationfield : any;
  clienttype : any;
  referralenable: boolean = true;
  referraldate : any;
  fp:functionpermission = new functionpermission();
  currentDateTime: string;
  isrejectreason:boolean = false;
  isonboard:boolean = false;
  isreject:boolean=false;
  ReferralDeleteId:any;
  isNotes: boolean = false;
  ActiveTab = "nav-general";
  isFieldEnabled: boolean = false;
  isRelationcontact: boolean = false;
  isEnabledcontact: boolean = false;
  contactfilter: any = "contacts";
  CaseStatus: any;
  CareStatus: any;
  StatusLst: any;
  clientcasemanagerandContactDetail: any;
  CareCoordinatorDropdownList: any;
  assignCare: AssignCareCoordinator = new AssignCareCoordinator();
  public datacase: Observable<DataStateChangeEventArgs>;
  deletecaseId: string;
  caseenable: boolean = false;
  assignCase: AssignCaseManager = new AssignCaseManager()
  CaseManagerDropdownList: any = [];
  getClientCasemanager: GetClientCasemanager = new GetClientCasemanager();
  caseLst: getMappedCMDataBO[] = [];
  saveclientcase: ClientCaseManagerRelationshipBO =
      new ClientCaseManagerRelationshipBO();
  AssignCaseManagerBoolean: boolean = false;
  assignCaseManager: any = null;
  @ViewChild("gridcasemanager") public gridcasemanager: GridComponent;
  
    //contact tab carecoodinator//
    deletecareId: string;
    careenable: boolean = false;
    caretype: string = "";
    isEditBoolean: boolean = false;
    isEditgeneralBoolean: boolean = false;
    isgeneraltabfieldview: boolean = false;
  
    public datacare: Observable<DataStateChangeEventArgs>;
    public data: Observable<DataStateChangeEventArgs>;
    ClientDataForm: FormGroup;
    CareCoordinatorinfo: CareCoordinatorInfoLst = new CareCoordinatorInfoLst();
    CareId: string = "";
    getClientCare: GetClientCarecoordinator = new GetClientCarecoordinator();
    assignCareCoordinator: any = null;
    addnewcareplan;
    areList: any = [];
    CareListDub: any = [];
    statusFilter: any;
    AssignCareCoordinatorBoolean: boolean = false;
    carecoLst: carecoordinate[] = [];
    saveclientcare: ClientCoordinatorRelationshipBO =
      new ClientCoordinatorRelationshipBO();
    @ViewChild('gridcarecoordinator') public gridcarecoordinator: GridComponent;
    ColumnArray_care: any;
    StatusFilterLst: any;
    casetype: string;
    ClientEmployeeContact: ClientEmployeeContactBO = new ClientEmployeeContactBO();
    deleteError: any = []
    // referral grid columns count for localStorage management
    ReferralTotalColumns:number=12;
  constructor(public CommonAPI: CommonApiService, public toastrService: ToastrService,    public CCESCare: ClientCreateEditCareService,
    private cdr: ChangeDetectorRef, public global: GlobalComponent, public dateservice: DateService,
    public ngxservice: NgxUiLoaderService, public RService: ReferralServices,
    public datepipe: DatePipe, private formBuilder: FormBuilder, public general: GeneralService,) {
    this.GridDataReferral = this.RService;
    this.Prospectivedata = CommonAPI;
    this.datacare = CCESCare;
    this.global.agencyList();
    this.currentDateTime = new Date().toISOString().slice(0, 16);
    // ...................ReferralForm..........................................
    this.ReferralForm = new FormGroup({
      firstName: new FormControl('', [Validators.required]),
      lastName: new FormControl('', [Validators.required]),
      genderLid: new FormControl('', [Validators.required]),
      middleName: new FormControl(''),
      ClientPhone1: new FormControl("", [Validators.minLength(14), Validators.maxLength(14)]),
      ClientPhone2: new FormControl("", [Validators.minLength(14), Validators.maxLength(14)]),
      referer_PhoneNumber: new FormControl("", [Validators.minLength(14), Validators.maxLength(14)]),
      insuranceNo: new FormControl('',[Validators.pattern('^[0-9]*$')]),
      PaySourceLid: new FormControl('',),
      clientTypeLid: new FormControl('',),
      typeofWaiverLid: new FormControl('',),
      medicaid: new FormControl('',[Validators.pattern('^[0-9]*$') , Validators.required]),
      medicare: new FormControl('',),
      referralStartTime: new FormControl('', [Validators.required]),
      dob: new FormControl('',),
      language: new FormControl('',),
      cfssModel: new FormControl('',),
      location: new FormControl('',[Validators.required]),
      street: new FormControl('', [Validators.required]),
      apt: new FormControl(''),
      city: new FormControl('', [Validators.required]),
      county: new FormControl('',),
      state: new FormControl('', [Validators.required]),
      zip: new FormControl('', [Validators.required]),
      referrerName: new FormControl('',),
      lastAssessmentDate: new FormControl('',),
      followupnotes: new FormControl('',),
      // rfr:new FormControl(''),
      ClientEmail: new FormControl('', [
        Validators.pattern('^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$')
      ]),
      referer_Email: new FormControl('', [

        Validators.pattern('^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$')
      ]),
    });

  }
  ngAfterContentChecked() {

    this.cdr.detectChanges();
    this.global.dashtoreferral = false;
  }

  ngOnInit(): void {
    this.clearGridLocalStorage();
    if (this.global.globalAgencyId == null || this.global.globalAgencyId == '' || this.global.globalAgencyId == undefined || this.global.globalAgencyId == '00000000-0000-0000-0000-000000000000') {
      return;
    }
    // this.ActiveTab = "nav-notes";
    // this.isNotes = true;
    this.global.referralcontact = true;
    if (this.global.globalLocationId != null && this.global.globalLocationId != ''
      && this.global.globalLocationId != undefined) {
      this.locationId = this.global.globalLocationId;
    }
    else {
      this.locationId = "00000000-0000-0000-0000-000000000000";;
    }
    this.CommonAPI.getStateJson().pipe(takeUntil(this.onDestroy$)).subscribe(data => {
      this.stateList = data;
    });
    this.filterSettings = { type: 'Menu' };
    this.initialPage = { currentPage: 1, totalRecordsCount: 0, pageCount: 10, pageSize: this.pageSizes[0], pageSizes: this.pageSizes };
    this.formatOptions1 = { type: 'date', format: 'MM/dd/yyyy' };
    this.formatOptions = { type: "date", format: "MM/dd/yyyy h:mm:ss a" };
    this.referralAge = 'UNDER'
    this.getstatus();
    this.getGender();
    this.getTypeofWaiver();
    this.getpaysource();
    this.getlanguage();
    this.getClientType();
    this.getLocationDropDown();
    this.filepermissionget();
    this.getStatusforCase();
    if(this.global.dashtoreferral)
    {
     
      this.referralstartDate = this.datepipe.transform(this.global.referralStartdate, "MM/dd/yyyy");
      this.referralendDate = this.datepipe.transform(this.global.referralEnddate, "MM/dd/yyyy");
      this.referralAge = (this.global.referralAge =='true')?'OVER':'UNDER';
      setTimeout(() => {  
        this.RBO.ReferralStatusLid = this.statusList?.filter(s=>s.lovName == this.global.referralStatus)[0]?.id;
      }, 2000);
    }
    setTimeout(() => {
      this.getReferralClient();
    }, 2500);
  }
    filepermissionget() {
      let params = new URLSearchParams();
      params.append("pagecode", "Referral");
      // params.append("roleId", this.global.roleId);
      let url = "api/FunctionPermission/getfunctionpermissionemployee?";
      this.CommonAPI.GetFunctionwithResponseTypeJson(params,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: functionpermission) => {
        this.fp = data;
      });
    }
  public dataStateChange(state): void {
    this.type = (state.action.requestType).toString();
    if (this.type != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.RBO.orderColumn = state.sorted[0].name;
        this.RBO.orderType = state.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
      }
    }
    if (this.type == "filtering" && state.action.action != "clearFilter") {
      this.RBO.field = state.action.currentFilterObject.field;
      this.RBO.matchCase = state.action.currentFilterObject.matchCase;
      this.RBO.operator = state.action.currentFilterObject.operator;
      this.RBO.value = state.action.currentFilterObject.value;
    }
    else {
      if (this.type == "filtering" && state.action.action == "clearFilter") {
        this.RBO.field = "clientName";
        this.RBO.matchCase = false;
        this.RBO.operator = "startswith";
        this.RBO.value = "";
      }
    }
    if (this.type == "paging" && state.action.name == "actionBegin") {
      if (this.arraycol.length != 0) {
        if (this.arraycol[0].Client_Intake_form_PendingList.Pagesize != state.take) {
          this.arraycol[0].Client_Intake_form_PendingList.Pagesize = state.take

        }
      }
    }

    this.ApplyFilter();
  }
  public onActionComplete(args) {
    if (args.requestType == "columnstate") {
      let hidearr = [];
      let showarr = [];
      this.gridProspective.columns.forEach(element => {
        if (element.visible == false && element.headerText != "Actions" && element.headerText != "") {
          hidearr.push(element.headerText);
        }
        if (element.visible == true && element.headerText != "Actions" && element.headerText != "") {
          showarr.push(element.headerText);
        }
      })
      var count = 0;
      var count1 = 0;
      if (args.columns.length > 0) {
        if (this.arraycol.length > 0) {
          this.arraycol[0].Client_Intake_form_PendingList.ShowColumns.forEach(old => {
            showarr.forEach(element => {
              if (old == element) {
                count1 = count1 + 1;
              }
            });
          });
          this.arraycol[0].Client_Intake_form_PendingList.HideColumns.forEach(old => {
            hidearr.forEach(element => {
              if (old == element) {
                count = count + 1;
              }
            });
          });
          if (this.arraycol[0].Client_Intake_form_PendingList.ShowColumns.length != count1 || this.arraycol[0].Client_Intake_form_PendingList.HideColumns.length != count) {
            this.arraycol[0].Client_Intake_form_PendingList.ShowColumns = showarr;
            this.arraycol[0].Client_Intake_form_PendingList.HideColumns = hidearr;

          }
        }
      }
    }
    this.RBO.currentpageno = this.gridProspective.pagerModule.pagerObj.currentPage;
    this.RBO.pageitem = this.gridProspective.pagerModule.pagerObj.pageSize;
    this.conditionlist = [];
    if (args.requestType === "filtering" && args.action === "filter") {
      args.columns.forEach(element => {
        this.conditionlist.push(element.properties);
      });
    }
  }
  onResize(args) {
    if (this.ColumnArray != null && this.ColumnArray != undefined) {
      const column = this.gridProspective.getColumnByField(args.column.field)
      column.width = args.column.width;
      this.ColumnArray.forEach(element => {
        if (element.column == column.headerText) {
          element.width = parseInt(column.width.toString());
        }
      });

    }
  }
show() {
  this.gridProspective.columnChooserModule.openColumnChooser(500, -250);
}
  getstatus() {
    let url = "api/LOV/getLovDropDown?"
    let params = new URLSearchParams();
    params.append("ListCode", 'REFERRALSTATUS');
    this.CommonAPI.getDropDownList("REFERRALSTATUS", params, url, "LovDropDown").then(
      (data: any) => {
        this.statusList = data;
        let val = data?.filter(s => s.lovName == "Pending");
        this.RBO.ReferralStatusLid = val[0]?.id;

      },
      (err) => { this.toastrService.error(err); }
    );
  }
  getGender() {
    let url = "api/LOV/getLovDropDown?"
    let params = new URLSearchParams();
    params.append("ListCode", "GENDER");
    this.CommonAPI.getDropDownList("GENDER", params, url, "LovDropDown").then(
      (data: any) => {
        this.genderList = data?.filter(ele=>ele.lovCode?.toUpperCase()!='OTHERS');
      },
      (err) => { this.toastrService.error(err); }
    );
  }
  getlanguage() {
    let url = "api/LOV/getLovDropDown?"
    let params = new URLSearchParams();
    params.append("ListCode", "Language");
    this.CommonAPI.getDropDownList("Language", params, url, "LovDropDown").then(
      (data: any) => {
        this.languageList = data;
      },
      (err) => { this.toastrService.error(err); }
    );
  }
  getTypeofWaiver() {
    let url = "api/LOV/getLovDropDown?"
    let params = new URLSearchParams();
    params.append("ListCode", "TYPEOFWAIVER");
    this.CommonAPI.getDropDownList("TYPEOFWAIVER", params, url, "LovDropDown").then(
      (data: any) => {
        this.TypeofWaiver = data;
      },
      (err) => { this.toastrService.error(err); }
    );
  }

  getpaysource() {
    let url = "api/LOV/getLovDropDown?"
    let params = new URLSearchParams();
    params.append("ListCode", "PAYSOURCE");
    this.CommonAPI.getDropDownList("PAYSOURCE", params, url, "LovDropDown").then(
      (data: any) => {
        this.PaySourceitem = data;
      },
      (err) => { this.toastrService.error(err); }
    );
  }

  //......................................getClientType.....................................
  getClientType() {
    let url = "api/LOV/getLovDropDown?";
    let params = new URLSearchParams();
    params.append("ListCode", "CLIENTTYPE");

    this.CommonAPI.getDropDownList('CLIENTTYPE', params, url, "LovDropDown").then((data: any) => {

      this.TypeofClient = data.map((element: any) => ({
        id: element.id,
        lovName: element.lovName,

      }));
    }, (err: any) => {
      this.toastrService.error(err);
    });
  } getLocationList: any = [];
  //............................................getLocationDropDown.............................................
  getLocationDropDown() {
    this.RService.GetLocationDropDown().pipe(takeUntil(this.onDestroy$)).subscribe((data) => {
      this.getLocationList = data;
      if (this.getLocationList.length > 0) {
        this.saveBo.locationId = (this.saveBo.locationId != null && this.saveBo.locationId != undefined) ? this.saveBo.locationId : this.getLocationList[0]?.Key;
      }
    },
      err => {
      })
  }

  newdates(event, type, name) {
 
    if (type == "inputchanged") {
      if (name == 'date') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          // this.saveBo.date = val1;
          this.saveBo.referralStartTime = val1;
          this.isIntakeBoolean = true;
        }
      }
      if (name == 'Startdate') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.referralstartDate = val1;
          this.isIntakeBoolean = true;
        }
      }
      if (name == 'Enddate') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);

          this.referralendDate = val1;
          this.isIntakeBoolean = true;
        }
      }
      if (name == 'lastassessment') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);

          this.saveBo.lastAssessmentDate = val1;
          // this.isIntakeBoolean = true;
        }
      }
      if (name == 'referral') {
  
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);

          this.saveBo.referralStartTime = val1;
          this.isIntakeBoolean = true;
        }
      }
    }
    if (type == "datechanged") {
      if (name == 'date') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          // this.saveBo.date = val1;
          this.saveBo.referralStartTime = val1;
          this.isIntakeBoolean = true;
        }
      }
      if (name == 'Startdate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.referralstartDate = val1;
          this.isIntakeBoolean = true;
          this.getValidationDate();
          this.clearEndTimeValidation();
        }
      }
      if (name == 'Enddate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.referralendDate = val1;
          this.isIntakeBoolean = true;
          this.clearEndTimeValidation();
        }
      }
      if (name == 'lastassessment') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.saveBo.lastAssessmentDate = val1;
          this.isIntakeBoolean = true;
        }
      }
      if (name == 'referral') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.saveBo.referralStartTime = val1;
          this.isIntakeBoolean = true;
        }
      }
    }
  }
  getValidationDate() {
    var StartDate = new Date(this.referralstartDate);
    let setDate = StartDate.setDate(StartDate.getDate() + 365);
    let getDate = setDate;
    this.ValidationDate = this.datepipe.transform(getDate, "MM/dd/yyyy");
  }
  clearEndTimeValidation() {
    if (this.referralstartDate != null && this.referralstartDate != undefined && this.referralstartDate != '' &&
      this.referralendDate != null && this.referralendDate != undefined && this.referralendDate != '') {
      let EndDate = this.datepipe.transform(this.referralendDate, "MM/dd/yyyy");
      if (new Date(EndDate).getTime() > new Date(this.ValidationDate).getTime()) {
        this.toastrService.error("Date range should not be greater than 1 year");
        this.referralendDate = null;

        setTimeout(() => {
          this.toastrService.clear();
        }, 3000);

      }
      if (this.referralendDate != null && this.referralendDate != undefined && this.referralendDate != '') {
        if (new Date(this.referralstartDate).getTime() > new Date(this.referralendDate).getTime()) {
          this.referralendDate = null;

          this.toastrService.error("end time should greater than start time");
          setTimeout(() => {
            this.toastrService.clear();
          }, 3000);
          return;
        }
      }
    }
  }
  keyPress(event: any) {
    const pattern = /[0-9]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
  CreateNewIntake() {
    this.ProspectiveCreate = true;
    this.ClientIntakeCreate = true;
    this.isApprovedRejectedFields = false;
    this.isViewApproveRejected = true;
    this.referralenable = true;
    this.global.referralId = "00000000-0000-0000-0000-000000000000";
    this.saveBo = new ReferralBo();
    this.global.referralTab = false;
    this.ActiveTab = 'nav-general';
  }
  isEditGridValues(data) {
    this.ReferralForm.controls.email?.setErrors(null)
    this.ProspectiveCreate = true;
    this.ClientIntakeCreate = true;
    this.isApprovedRejectedFields = false;
    this.referralenable = true;
    if (data.referralStatus == 'Pending' || data.referralStatus == 'PENDING') {
      this.isViewApproveRejected = false;
    }
    else {
      this.isViewApproveRejected = true;
    }
    this.global.referralTab = false;
  }
  isViewGridValues() {
    this.ReferralForm.disable();
    this.referralenable = false;
    this.isApprovedRejectedFields = true;
    this.isViewApproveRejected = true;
    this.ProspectiveCreate = true;
    this.ClientIntakeCreate = true;
    this.global.referralTab = true;
  }
  // Apply///
  ApplyFilter() {
    this.getReferralClient();
  }
  RefreshIntake() {
    this.ngxservice.start()
    this.RBO.orderColumn = "clientName";
    this.RBO.orderType = "asc";
    this.RBO.field = "clientName";
    this.RBO.referralAge = 'UNDER';
    this.referralAge ='UNDER';
    this.RBO.languageLIds = [];
    this.clientName  ='';
    this.referralstartDate = null;
    this.referralendDate = null;
    this.RBO = new GetReferalListBo();
    let val = this.statusList?.filter(s => s.lovName == "Pending");
    this.RBO.ReferralStatusLid = val[0]?.id;
    this.ReferralStatusLid = val[0]?.id;
    this.getReferralClient();
    this.gridProspective.dataSource = []
    this.gridProspective.clearFiltering();
    this.gridProspective.clearSorting();
    this.ngxservice.stop()

  }
  // Pending//
  getReferralClient() {
    this.RBO.role = localStorage.getItem('CFSS_role');
    
    if (this.referralstartDate != null && this.referralstartDate != undefined && this.referralstartDate != '') {
      this.RBO.referralstartDate = (new Date(new Date(this.referralstartDate).toDateString() + " " + "00:00:00" + " " + "GMT").toISOString()).replace("Z", "");
    }
    if (this.referralendDate != null && this.referralendDate != undefined && this.referralendDate != '') {
      this.RBO.referralEndDate = (new Date(new Date(this.referralendDate).toDateString() + " " + "00:00:00" + " " + "GMT").toISOString()).replace("Z", "");
    }
    // this.RBO.locationId = (this.locationId != null && this.locationId != undefined && this.locationId != "00000000-0000-0000-0000-000000000000") ? this.locationId.toString() : "00000000-0000-0000-0000-000000000000";
    this.RBO.userid = (this.global.userID != null && this.global.userID != undefined) ? this.global.userID : "00000000-0000-0000-0000-000000000000";
    // this.RBO.value = this.clientName;
    this.RBO.SearchText = this.clientName;
    this.RBO.referralAge = this.referralAge;
    if(this.RBO.referralAge =='UNDER')
    {
      this.RBO.referralstartDate = null;
      this.RBO.referralEndDate = null;
    }
    let responseData =
    {
      result: "result",
      count: "count",
    }
    let url = "api/Referral/GetReferralList"
    this.CommonAPI.outputValues(url, this.RBO, responseData, "");
    let count = 0
    this.Prospectivedata.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.ProspectiveList = data.result;
  
      count = count + 1;
      if (data != null && data != undefined && count == 1) {
      }

      if (data.count > 15) {
        this.gridProspective.height = '500';
      }
      else {
        this.gridProspective.height = 'auto';
      }
    });
  }

  selectProspectivedetails(IntakeClientDetails) {
    this.ActiveTab = "nav-notes";
    this.isNotes = true;
    this.global.referralId = IntakeClientDetails?.id;
    this.ClientEmployeeContact.Id = this.global.referralId;
    this.ClientEmployeeContact.ContactType = "Referral";
    this.saveBo = JSON.parse(JSON.stringify(IntakeClientDetails));
    this.saveBo.dOB =  IntakeClientDetails.dob;
    this.ReferralForm.get('dob').setValue(new Date(IntakeClientDetails.dob));
    this.ReferralForm.get('lastAssessmentDate').setValue(new Date(IntakeClientDetails.lastAssessmentDate));
    this.saveBo.age = IntakeClientDetails.age.toString();
    this.selectedLanguages = IntakeClientDetails?.languages?.map(language => language?.Key);
    this.languagefields = IntakeClientDetails?.languages?.map(language => language?.Value);
    this.genderfields = this.genderList.filter(a=> a?.id == this.saveBo?.genderLid)[0]?.lovName;
    this.waiverfield = this.TypeofWaiver.filter(a=> a?.id == this.saveBo?.typeofWaiverLid)[0]?.lovName;
    this.paysourcfield = this.PaySourceitem.filter(a=> a?.id == this.saveBo?.paySourceLid)[0]?.lovName;
    this.locationfield = this.getLocationList.filter(a=>a?.Key == this.saveBo?.locationId)[0]?.Value;
    this.clienttype = this.TypeofClient.filter(a=> a?.id == this.saveBo?.clientTypeLid)[0]?.lovName;
 
    if(IntakeClientDetails.referralStatus == 'Rejected'||IntakeClientDetails.referralStatus == 'REJECTED')
      this.isrejectreason= true;
    else
     this.isrejectreason = false;
    setTimeout(() => {
      this.saveBo.lastAssessmentDate = this.datepipe.transform(this.saveBo.lastAssessmentDate, "MM/dd/yyyy");
      this.saveBo.dOB =  this.datepipe.transform(this.saveBo.dOB, "MM/dd/yyyy");
      this.saveBo.referralStartTime = this.datepipe.transform(this.saveBo.referralStartTime,  "yyyy-MM-dd HH:mm:ss");

    }, 1000);
  }
 
  // SaveReferral///
  SaveOrUpdateIntakeClientDetails() {
    let prospectiveSaveIntake: ReferralBo = JSON.parse(JSON.stringify(this.saveBo));
    prospectiveSaveIntake.id = prospectiveSaveIntake.id;
    prospectiveSaveIntake.age = Math.floor(Number(this.saveBo.age));
    prospectiveSaveIntake.dOB = this.global.getDateTimeString(this.saveBo.dOB);
    if (this.saveBo.lastAssessmentDate)
      prospectiveSaveIntake.lastAssessmentDate = this.global.getDateTimeString(this.saveBo.lastAssessmentDate);
    this.referraldate = this.saveBo.referralStartTime
    if (this.saveBo.referralStartTime)
      prospectiveSaveIntake.referralStartTime = this.global.getDateTimeString(this.saveBo.referralStartTime);
    prospectiveSaveIntake.agencyId = this.global.globalAgencyId;
    prospectiveSaveIntake.languageLids = this.selectedLanguages;
    if(this.selectedLanguages == null)
    {
      prospectiveSaveIntake.languageLids = [];
    }
    let url = 'api/Referral/SaveReferral';
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(prospectiveSaveIntake, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      if (prospectiveSaveIntake.id == "00000000-0000-0000-0000-000000000000") {
        prospectiveSaveIntake.id = data;
        this.saveBo.id = data;
        this.global.referralId = data;
        this.ProspectiveCreate = true;
        this.ClientIntakeCreate = true;
        this.isApprovedRejectedFields = false;
        this.referralenable = true;
        this.isViewApproveRejected = false;
        this.ClientEmployeeContact.Id = this.global.referralId;
        this.ClientEmployeeContact.ContactType = "Referral";
        this.toastrService.success('Referral saved successFully!')
        // this.closeProspectiveIntakeform();
      }
      else if (prospectiveSaveIntake.id != "00000000-0000-0000-0000-000000000000") {
        this.isIntakeBoolean = false;
        this.toastrService.success('Referral updated successFully');
        
      }
      if(this.isonboard)
      {
        this.SaveApprovedIntakeClient();
      }
      if(this.isreject)
      {
        this.ConfirmRejection();
      }
      setTimeout(() => {
        this.toastrService.clear();
      }, 8000);
    },
      (err: any) => {
        this.toastrService.error(
          err
        );
      })
  }

  // Approved//
  SaveApprovedIntakeClient() {
    let param = new URLSearchParams();
    param.append("FormId", this.global.referralId);
    let url = 'api/Referral/ApproveReferral?';
    this.CommonAPI.saveorUpdateFunctionwithParams(param, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.closeProspectiveIntakeform();
      this.toastrService.success('Referral approved successFully!')
      setTimeout(() => {
        this.toastrService.clear();
      }, 8000);
    },
      (err: any) => {
        this.toastrService.error(
          err
        );
      })
  }

  ConfirmRejection() {
    let param = new URLSearchParams();
    param.append("FormId", this.global.referralId);
    // param.append("reasonForRejection", this.rejectedItems.reasonForRejection);
    let url = "api/Referral/RejectReferral?";
    this.CommonAPI.saveorUpdateFunctionwithParams(param, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.toastrService.success("Referral rejected successFully!")
      this.closeProspectiveIntakeform();
    },
      (err: any) => {
        this.toastrService.error(
          err,
          "error",
        );
      })

  }
  changeFunction() {
    this.isIntakeBoolean = true;
  }
  checkEmailValidation() {
    this.intakeEmail = false
    if (this.saveBo.email != null) {
      if (this.ReferralForm.controls.email.errors != null) {
        if (this.ReferralForm.controls.email.errors.invalidEmail) {
          this.intakeEmail = true
          setTimeout(() => {
            this.toastrService.clear();
          }, 1000);
        }
        else {
          this.intakeEmail = false
        }
      }


    }
  }
  isAnyFieldDirty(): boolean {
    return Object.keys(this.ReferralForm.controls).some(key => this.ReferralForm.get(key).touched);
  }
  
  alertMessageModal() {
    let isDirtyReferralForm = this.isAnyFieldDirty()
    if (isDirtyReferralForm == true) {
      document.getElementById("openCloseModal").click();
    }
    else {
      this.closeProspectiveIntakeform();
    }
  }
  onboardclient(){
      document.getElementById('opensaveModal').click();
  }
 saveonboard(){
  this.SaveOrUpdateIntakeClientDetails();
  
 }
 dontsaveonboard(){
  this.SaveApprovedIntakeClient();
 }
   // Rejected/
 RejectIntakeProcess() {
      document.getElementById("openrejectModal").click();
  }
  savereject(){
    this.SaveOrUpdateIntakeClientDetails();
    
  }
  dontsavereject(){
    this.ConfirmRejection();
  }

  // closeProspectiveIntakeform() {
  //   this.rejectedItems.reasonForRejection = null;
  //   this.ClientIntakeCreate = false;
  //   this.ProspectiveCreate = false;
  //   this.isIntakeBoolean = false;
  //   // this.referralstartDate = null;
  //   // this.referralendDate = null;
  //   this.RBO = new GetReferalListBo();
  //   this.ReferralForm.reset();
  //   this.ReferralForm.enable();
  //   let val = this.statusList?.filter(s => s.lovName == "Pending");
  //   this.RBO.ReferralStatusLid = val[0]?.id;
  //   this.ReferralStatusLid = val[0]?.id;
  //   this.AddressGoogleMap=false;
  //   this.isonboard=false;
  //   this.isreject=false;
  //   this.global.referralId = "00000000-0000-0000-0000-000000000000";
  //   this.global.referralTab = false;
  //   this.getReferralClient();
  // }
closeProspectiveIntakeform() {
  this.rejectedItems.reasonForRejection = null;
  this.ClientIntakeCreate = false;
  this.ProspectiveCreate = false;
  this.isIntakeBoolean = false;
  
  this.ReferralForm.reset();
  this.ReferralForm.enable();
  
  this.AddressGoogleMap = false;
  this.isonboard = false;
  this.isreject = false;
  this.global.referralId = "00000000-0000-0000-0000-000000000000";
  this.global.referralTab = false;
  
  // REMOVE THESE LINES - they were resetting your filters:
  // this.referralstartDate = null;
  // this.referralendDate = null;
  // this.RBO = new GetReferalListBo();
  // let val = this.statusList?.filter(s => s.lovName == "Pending");
  // this.RBO.ReferralStatusLid = val[0]?.id;
  // this.ReferralStatusLid = val[0]?.id;
  
  // Just refresh the grid with existing filters
  this.getReferralClient();
}
  printIntakeforms() {
   
    this.pdfIntakeformList.A4 = true,
      this.pdfIntakeformList.portrait = true,
      this.pdfIntakeformList.keepTogether = ".prevent-split",
      this.pdfIntakeformList.scale = 0.8,
      this.pdfIntakeformList.height = 100,
      this.pdfIntakeformList.margin = { left: "1.2cm", top: "1cm", right: "0.2cm", bottom: "1cm", }
    this.pdfIntakeformList.padding = { bottom: "50px" };
    this.pdfIntakeformList.saveAs(
      "Prospective-client-intakeformReport" +
      new Date().toLocaleDateString() +
      "-" +
      new Date().toLocaleTimeString()
    );

  }

  //.............................................. DOBdatechange..............................................
  DOBdatechange(event: IMyInputFieldChanged) {
    let value = event.value;
    if (value.length >= 7 && value.substring(2, 3) != '/') {
      this.saveBo.dOB = value.substring(0, 2) + '/' + value.substring(2, 4) + '/' + value.substring(4);
    }


  }

  //............................................. CLIENT DOB CHNAGE............................................ 
  onDateChanged(event: IMyDateModel) {
    this.saveBo.dOB = event.formatted;
    var bdate = new Date(event.formatted);
    var today = new Date();
    var bdate = new Date(event.formatted);
    var age = 0;
    if (bdate.getFullYear() >= today.getFullYear()) {
      age = 0
    }
    else {
      var age = today.getFullYear() - bdate.getFullYear();
      var m = today.getMonth() - bdate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < bdate.getDate())) {
        age--;
      }
    }
    this.saveBo.age = age;
    if (this.saveBo.dOB == null || this.saveBo.dOB == undefined || this.saveBo.dOB == '') {
      this.saveBo.age = null;
    }
  }

  //......................................DemographicPhoneFormat....................................
  DemographicPhoneFormat() {
    this.saveBo.phone1 = this.general.converPhoneGoogleLib(this.saveBo.phone1);
    this.saveBo.phone2 = this.general.converPhoneGoogleLib(this.saveBo.phone2);
    this.saveBo.billto_Phone = this.general.converPhoneGoogleLib(this.saveBo.billto_Phone);
    // this.saveBo.participant_PhoneNumber = this.general.converPhoneGoogleLib(this.saveBo.participant_PhoneNumber);
    this.saveBo.referer_PhoneNumber = this.general.converPhoneGoogleLib(this.saveBo.referer_PhoneNumber)

  }



  //......................................EmitGoogleMapComponent.....................................
  EmitGoogleMapComponent(event) {
    this.saveBo.zipCode = "";
    this.saveBo.street = "";
    this.saveBo.city = "";
    this.saveBo.county = "";
    this.saveBo.state = "";
    this.saveBo.apt = "";
    let street = "";
    if (
      event.address_components != null &&
      event.address_components != undefined
    ) {
      event.address_components.forEach((outerArray) => {
        outerArray?.types.forEach((innerArray) => {
          if (innerArray == "administrative_area_level_2") {
            this.saveBo.county = outerArray.long_name;
          }
          if (innerArray == "postal_code") {
            this.saveBo.zipCode = outerArray.long_name;
          }
          if (innerArray == "administrative_area_level_1") {
            if (outerArray.long_name != null) {
              let state = this.stateList?.filter(
                (a) => a.name == outerArray.long_name
              )[0];

              this.saveBo.state = state != null ? state.abbreviation : null;
            }
          }
          if (innerArray == "subpremise") {
            let apt = outerArray.long_name.split(" ")[1];
            this.saveBo.apt = (apt != undefined && apt != null && apt != '') ? apt : outerArray.long_name;
          }
          if (innerArray == "street_number") {
            street = (outerArray.long_name != undefined && outerArray.long_name != null) ? outerArray.long_name + ' ' : '';
          }
          if (innerArray == "route") {
            this.saveBo.street = street + outerArray.short_name;
          }
        });
      });
    }
    if (event.formatted_address != null) {
      var addressFormat = event.formatted_address.split(",");
      this.saveBo.street = addressFormat[0];
      this.saveBo.city = addressFormat[1];
    }
    // this.saveBo.clientLocationLatitude = (event.clientLocationLatitude !=null && event.clientLocationLatitude !=undefined) ? event.clientLocationLatitude : null;
    // this.saveBo.clientLocationLongitude = (event.clientLocationLongitude != null && event.clientLocationLongitude != undefined) ? event.clientLocationLongitude : null
    // this.changevalue = event.isChanged;
    document.getElementById('openSearchAddressModal').click();
  }
  //......................................getzipcodeClient.....................................
  getzipcodeClient() {
    let myParams1 = new URLSearchParams();
    myParams1.append("Street", this.saveBo.street);
    myParams1.append("City", this.saveBo.city);
    myParams1.append("State", this.saveBo.state);
    let url = "api/Client/getZipcode?"
    this.CommonAPI
      .GetFunctionwithResponseTypeJson(myParams1, url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          this.saveBo.zipCode = data.zipcode;
          this.saveBo.county = data.county;
        },
        (err: any) => {
          if (err) {
            this.toastrService.error(err, "Error"), 8000;
          }
        }
      );
  }
  adjustTextareaSize(event: Event): void {
    const textarea = document.getElementById('followUpNotes') as HTMLTextAreaElement;
    if (textarea) {
      textarea.style.height = `${textarea.scrollHeight}px`; // Set height to scrollHeight
    } 
  }
  bindprint(){
    this.genderfields = this.genderList.filter(a=> a?.id == this.saveBo?.genderLid)[0]?.lovName;
    this.languagefields = this.languageList?.filter(item => this.selectedLanguages?.includes(item?.id))?.map(item => item?.lovName);
    this.waiverfield = this.TypeofWaiver.filter(a=> a?.id == this.saveBo?.typeofWaiverLid)[0]?.lovName;
    this.paysourcfield = this.PaySourceitem.filter(a=> a?.id == this.saveBo?.paySourceLid)[0]?.lovName;
    this.locationfield = this.getLocationList.filter(a=>a?.Key == this.saveBo?.locationId)[0]?.Value;
    this.clienttype = this.TypeofClient.filter(a=> a?.id == this.saveBo?.clientTypeLid)[0]?.lovName;
  }
  getDeleteId(data) {
    this.ReferralDeleteId = data.id;
    this.getClientdeleteError();
  }
      getClientdeleteError() {
        this.deleteError = []
        let params = new URLSearchParams();
        params.append("Id", this.ReferralDeleteId?.toString());
        let url = "api/Referral/CheckReferralToDelete?"
        this.CommonAPI.GetFunctionwithResponseTypeJson(params, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
          if (data?.length != 0) {
            this.deleteError = data
            document.getElementById('openDeleteErrorModal').click();
          } else {          
            document.getElementById('openReferalDelete').click();
            this.deleteError = []
          }
        },
          (err: HttpErrorResponse) => {
    
            this.toastrService.error(err.error, "error");
          })
      }
  DeleteReferral() {
    let params = new URLSearchParams();
    params.append("ReferralId", this.ReferralDeleteId);
    this.RService.DeleteReferral(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.toastrService.success("Referral Deleted Successfully");
      document.getElementById("openReferalDelete").click();
      this.getReferralClient();
      setTimeout(() => {
        this.toastrService.clear();
      }, 8000);
    },
      (err: any) => {
        this.toastrService.error(err, " Error");
        setTimeout(() => {
          this.toastrService.clear();
        }, 2000);
      })
  }
  getTabActiveData(Tabtocall) {
    if (this.ActiveTab == "nav-contacts") {
      this.contactfilter = 'contacts'
      // this.getClientcasemanagerandContactDetails();

    }
    this.ActiveTab = Tabtocall;
    if (Tabtocall == "nav-notes") {
      this.isNotes = true;
    }
    if (Tabtocall != "nav-notes") {
      this.isNotes = false;
    }



    if (Tabtocall == "nav-general") {
      this.isFieldEnabled = false;
    }

    if (Tabtocall == "nav-contacts") {
      this.isRelationcontact = true;

    }


    if (Tabtocall != "nav-contacts") {
      this.isEnabledcontact = false;
      this.isRelationcontact = false;

    }

  
    
    
  }
  //......................................callingfunction.....................................
  callingfunction() {
    if (this.contactfilter == "contacts") {
      this.isRelationcontact = true;
    }
    else if (this.contactfilter == "case") {
      this.CaseStatus = this.StatusLst.filter(st => st.lovCode == "ACTIVE")[0].id;
      this.isRelationcontact = false;
      this.getCaseManagerDropdown()
      this.getclientCaseLst();
    }
    else if (this.contactfilter == "care") {
      this.CareStatus = this.StatusLst.filter(st => st.lovCode == "ACTIVE")[0].id;
      this.isRelationcontact = false;
      this.getCareCoordinatordropdown()
      this.getclientCareLst();
    }
    // else if (this.contactfilter == "House") {
    //   this.HouseStatus = this.StatusFilterLst.filter(ele=>ele.Value=="Active")[0].Key
    //   this.getHousingCoordinatordropdown()
    //   this.isRelationcontact = false;
    //   this.getclientHousingLst();
    // }
    // this.getClientcasemanagerandContactDetails();
  }

    getCaseManagerDropdown() {
      this.assignCase = new AssignCaseManager();
      let url = "api/ClientCaseManagerRelationship/GetCaseManagerDropdown?";
      this.CommonAPI.GetFunctionwithResponseTypeJson("", url)
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(
          (data: any) => {
            this.CaseManagerDropdownList = data;
            this.CaseManagerDropdownList.forEach(element => {
              element.Key = element.Key?.toString();
              element.Value = element.Value?.toString();
            });
  
          },
          (err: any) => {
            this.toastrService.error(err);
          }
        );
    }
  
    getclientCaseLst() {
      if (this.CaseStatus == null) {
        this.getClientCasemanager.statusLid = "00000000-0000-0000-0000-000000000000";
      }
      this.getClientCasemanager.clientId = this.global.clientId;
      this.getClientCasemanager.statusLid = this.CaseStatus;
      this.getClientCasemanager.referralId = this.global.referralId;
      let url = "api/ReferralCaseManagerRelationship/GetReferralCaseManagerRelationshipList";
      let responseData = {
        result: "result",
        count: "count",
      };
  
      this.CommonAPI.outputValues(url, this.getClientCasemanager, responseData, "");
      this.Prospectivedata.pipe(takeUntil(this.onDestroy$)).subscribe((datacase: any) => {
  
        this.caseLst = datacase.result;
        this.caseLst.forEach((c) => {
          c.fax != null
            ? this.general.reconverPhoneGoogleLibhttpsave(c.fax)
            : null;
          c.alternateFax != null
            ? this.general.reconverPhoneGoogleLibhttpsave(c.alternateFax)
            : null;
          c.phone != null
            ? this.general.reconverPhoneGoogleLibhttpsave(c.phone)
            : null;
        });
      },
        (err: any) => {
          this.toastrService.error(err);
        }
      );
    }
  
  
  
    getStatusforCase() {
      let url = 'api/LOV/getLovDropDown?'
      let params = new URLSearchParams();
      params.append("ListCode", "STATUS");
      this.CommonAPI.getDropDownList('STATUS', params, url, "LovDropDown").then((data: any) => {
  
        this.StatusLst = data;
        this.StatusLst.push({ lovVaule: 'All', lovName: "All" });
        this.CaseStatus = this.StatusLst.filter(st => st.lovCode == "ACTIVE")[0].id;
      },
        (err: any) => {
          this.toastrService.error(err);
          setTimeout(() => {
            this.toastrService.clear();
          }, 8000);
        }
      );
  
    }
  
  
    newdatescontact(event, type, name) {
      if (type == "inputchange") {
        if (name == 'ActiveDate') {
          let val = this.dateservice.inputFeildchange(event);
          if (val != undefined) {
            let val1 = this.dateservice.inputFeildchange(event);
            this.assignCase.activeDate = val1;
          }
        }
  
        if (name == 'InActiveDate') {
          let val = this.dateservice.inputFeildchange(event);
          if (val != undefined) {
            let val1 = this.dateservice.inputFeildchange(event);
            this.assignCase.inActiveDate = val1;
          }
  
        }
  
        if (name == 'CareActiveDate') {
          let val = this.dateservice.inputFeildchange(event);
          if (val != undefined) {
            let val1 = this.dateservice.inputFeildchange(event);
            this.assignCare.activeDate = val1;
          }
        }
        if (name == 'CareInActiveDate') {
          let val = this.dateservice.inputFeildchange(event);
          if (val != undefined) {
            let val1 = this.dateservice.inputFeildchange(event);
            this.assignCare.inActiveDate = val1;
          }
        }
  
      }
      if (type == "datechanged") {
        if (name == 'ActiveDate') {
          let val = this.dateservice.Datechange(event);
          if (val != undefined) {
            let val1 = this.dateservice.Datechange(event);
            this.assignCase.activeDate  = val1;
          }
  
        }
  
        if (name == 'InActiveDate') {
          let val = this.dateservice.Datechange(event);
          if (val != undefined) {
            let val1 = this.dateservice.Datechange(event);
            this.assignCase.inActiveDate = val1;
          }
        }
  
        if (name == 'CareActiveDate') {
          let val = this.dateservice.Datechange(event);
          if (val != undefined) {
            let val1 = this.dateservice.Datechange(event);
            this.assignCare.activeDate = val1;
          }
        }
        if (name == 'CareInActiveDate') {
          let val = this.dateservice.Datechange(event);
          if (val != undefined) {
            let val1 = this.dateservice.Datechange(event);
            this.assignCare.inActiveDate = val1;
          }
        }
  
      }
    }
  
  
  
    closecasemanager() {
      document.getElementById("casemanager").click();
      
    }
    closecase() {
      document.getElementById("Caseopen").click();
      
    }
    evenfromcase(event) {
      this.saveclientcase.caseManagerId = event;
      this.saveclientcase.clientId = this.global.clientId;
      this.saveclientcase.activeDate = this.assignCase.activeDate;
      this.saveclientcase.inActiveDate = this.assignCase.inActiveDate;
      this.saveclientcare.referralId = this.global.referralId;
      let url =
        "api/ReferralCaseManagerRelationship/SaveReferralCaseManagerRelationship";
      this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(this.saveclientcase, url)
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(
          (data: any) => {
            this.caseenable = false;
            document.getElementById("Caseopen").click();
            this.getclientCaseLst();
            // this.getClientcasemanagerandContactDetails();
          },
          (err: any) => {
            this.toastrService.error(err, "error");
            setTimeout(() => {
              this.toastrService.clear();
            }, 8000);
          }
        );
    }
  
    AssignCase() {
      var saveList: AssignCaseManager = JSON.parse(JSON.stringify(this.assignCase));
      saveList.activeDate = (saveList?.activeDate != null && saveList?.activeDate != undefined
        && saveList?.activeDate != "") ? this.global.getDateTimeString(saveList.activeDate) : null;
      saveList.inActiveDate = (saveList?.inActiveDate != null && saveList?.inActiveDate != undefined
        && saveList?.inActiveDate != "") ? this.global.getDateTimeString(saveList?.inActiveDate) : null;
      saveList.caseManagerId = saveList.caseManagerId
      saveList.clientId = this.global.clientId;
      saveList.referralId = this.global.referralId;
      if (saveList.activeDate != null && saveList.inActiveDate != null) {
        if (new Date(saveList.activeDate).getTime() > new Date(saveList.inActiveDate).getTime()) {
          this.toastrService.error("End Date should greater than Start Date");
          this.assignCase.inActiveDate = ''
          return;
        }
      }
      let url =
        "api/ReferralCaseManagerRelationship/SaveReferralCaseManagerRelationship";
      this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(saveList, url)
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(
          (data: any) => {
            this.caseenable = false;
            if (this.assignCase.id != undefined && this.assignCase.id != null) {
              this.toastrService.success('Case Manager updated successfully!');
  
            } else {
              this.toastrService.success('Case Manager Assigned successfully!');
  
              this.CaseStatus = this.StatusLst.filter(st => st.lovCode == "ACTIVE")[0].id;
  
  
            }
            document.getElementById("Caseopen").click();
            this.getclientCaseLst();
            // this.getClientcasemanagerandContactDetails();
          },
          (err: any) => {
            this.toastrService.error(err, "error");
            setTimeout(() => {
              this.toastrService.clear();
            }, 8000);
          }
        );
    }
    public dataStateChangeCasemanager(state): void {
      let val = state.action.requestType.toString();
      if (val != "filterchoicerequest") {
        if ((state.sorted || []).length) {
          this.getClientCasemanager.orderColumn = "CaseManagerName";
          this.getClientCasemanager.orderType = "asc";
        }
      }
  
      if (val == "filtering" && state.action.action != "clearFilter") {
        this.getClientCasemanager.field = state.action.currentFilterObject.field;
        this.getClientCasemanager.matchCase =
          state.action.currentFilterObject.matchCase;
        this.getClientCasemanager.operator =
          state.action.currentFilterObject.operator;
        this.getClientCasemanager.value = state.action.currentFilterObject.value;
      } else {
        if (val == "filtering" && state.action.action == "clearFilter") {
          this.getClientCasemanager.field = "CaseManagerName";
          this.getClientCasemanager.matchCase = false;
          this.getClientCasemanager.operator = "contains";
          this.getClientCasemanager.value = "";
          this.getClientCasemanager.type = "string";
          this.getClientCasemanager.clientId = this.global.clientId;
          this.getClientCasemanager.referralId = this.global.referralId;
        }
      }
      if (val == "paging" && state.action.name == "actionBegin") {
        // if (this.grid.pagerModule.pagerObj.pageSize != this.arraycol[0].Client.Pagesize) {
        if (this.arraycol.length != 0) {
          if (this.arraycol[0].Client_Casemanager.Pagesize != state.take) {
            this.arraycol[0].Client_Casemanager.Pagesize = state.take;
            // this.SaveColumnwidth();
            // }
          }
        }
      }
      this.getclientCaseLst();
  
    }
  
  
    public onActionCompleteCasemanager(args) {
      this.getClientCasemanager.currentpageno =
        this.gridcasemanager.pagerModule.pagerObj.currentPage;
      this.getClientCasemanager.pageitem =
        this.gridcasemanager.pagerModule.pagerObj.pageSize;
  
      if (args.name == "actionBegin" && args.requestType == "filterbeforeopen") {
        this.getClientCasemanager.type = args.columnType;
      }
    }
  
  
    deleteCase() {
      let params = new URLSearchParams();
      params.append("Id", this.deletecaseId.toString());
      let url =
        "api/ReferralCaseManagerRelationship/DeleteReferralCaseManagerRelationship?";
      this.CommonAPI.DeleteFunctionForDeleteHttp(params, url)
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(
          (data: any) => {
            this.toastrService.success(
              "Client Case Manager deleted successfully!"
            );
            document.getElementById("deletecasemanger").click();
            setTimeout(() => {
              this.toastrService.clear();
            }, 8000);
            // this.getClientcasemanagerandContactDetails();
            this.getclientCaseLst();
            document.getElementById("deletecasemanger").click();
          },
          (err: any) => {
            this.toastrService.error(err, "error");
            setTimeout(() => {
              this.toastrService.clear();
            }, 8000);
          }
        );
    }
  
  
    editcasemanager(data) {
      this.assignCase = data
      this.assignCase.caseManagerId = data.caseManagerId?.toString()
      this.assignCase.activeDate = this.datepipe.transform(data?.activeDate, 'MM/dd/yyyy')
      this.assignCase.inActiveDate = this.datepipe.transform(data?.inActiveDate, 'MM/dd/yyyy')
  
    }
  
  
    //......................................closecarecoordinator.....................................
    closecarecoordinator() {
      document.getElementById("Careopen").click();
  
    }
  
    //......................................onResize.....................................
    onResizecare(args) {
      if (this.ColumnArray_care != undefined && this.ColumnArray_care != null) {
        const column = this.gridcarecoordinator.getColumnByField(args.column.field);
        column.width = args.column.width;
        this.ColumnArray_care.forEach((element) => {
          if (element.column == column.headerText) {
            element.width = parseInt(column.width.toString());
          }
        });
        // this.SaveColumnwidth();
      }
    }
  
  
  
    //......................................AssignCare.....................................
    AssignCare() {
      var saveList: AssignCareCoordinator = JSON.parse(JSON.stringify(this.assignCare));
      saveList.activeDate = (saveList?.activeDate != null && saveList?.activeDate != undefined
        && saveList?.activeDate != "") ? this.global.getDateTimeString(saveList.activeDate) : null;
      saveList.inActiveDate = (saveList?.inActiveDate != null && saveList?.inActiveDate != undefined
        && saveList?.inActiveDate != "") ? this.global.getDateTimeString(saveList?.inActiveDate) : null;
      saveList.careCoordinatorId = (saveList.careCoordinatorId?.toString())
      saveList.clientId = this.global.clientId;
      saveList.referralId = this.global.referralId;
      if (saveList.activeDate != null && saveList.inActiveDate != null) {
        if (new Date(saveList.activeDate).getTime() > new Date(saveList.inActiveDate).getTime()) {
          this.toastrService.error("End Date should greater than Start Date");
          this.assignCare.inActiveDate = ''
          return;
        }
      }
      let url =
        "api/ReferralCareCoordinatorRelationship/SaveReferralCoordinatorRelationship";
      this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(saveList, url)
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(
          (data: any) => {
            this.careenable = false;
  
            if (this.assignCare.id != undefined && this.assignCare.id != null ) {
              this.toastrService.success('Care Coordinator updated successfully!');
  
            } else {
              this.toastrService.success('Care Coordinator Assigned successfully!');
              this.CareStatus = this.StatusFilterLst?.filter(ele => ele.lovCode == "ACTIVE")[0].id;
  
            }
            document.getElementById("Careopen").click();
            this.getclientCareLst();
            // this.getClientcasemanagerandContactDetails();
          },
          (err: any) => {
            this.toastrService.error(err, "error");
            setTimeout(() => {
              this.toastrService.clear();
            }, 8000);
          }
        );
  
  
    }
    //.................................................getStatusforFilter........................................................
    getStatusforFilter() {
          let url = 'api/LOV/getLovDropDown?'
          let params = new URLSearchParams();
          params.append("ListCode", "STATUS");
          this.CommonAPI.getDropDownList('STATUS', params, url, "LovDropDown").then((data: any) => {
      
            this.StatusFilterLst = data;
            this.StatusFilterLst.push({ lovVaule: 'All', lovName: "All" });
            this.CareStatus = this.StatusFilterLst.filter(st => st.lovCode == "ACTIVE")[0].id;
  
          },
        (err: any) => {
          this.toastrService.error(err);
          setTimeout(() => {
            this.toastrService.clear();
          }, 8000);
        }
      );
    }
    //......................................editcaremanager.....................................
    editcaremanager(data) {
      this.assignCare = data
      this.assignCare.careCoordinatorId = data?.careCoordinatorId?.toString();
      this.assignCare.activeDate = this.datepipe.transform(data?.activeDate, 'MM/dd/yyyy')
      this.assignCare.inActiveDate = this.datepipe.transform(data?.inActiveDate, 'MM/dd/yyyy')
    }
  
    //......................................dataStateChangeCare.....................................
    public dataStateChangeCare(state): void {
      let val = state.action.requestType.toString();
      if (val != "filterchoicerequest") {
        if ((state.sorted || []).length) {
          this.getClientCare.orderColumn = "CaseManagerName";
          this.getClientCare.orderType = "asc";
        }
      }
  
      if (val == "filtering" && state.action.action != "clearFilter") {
        this.getClientCare.field = state.action.currentFilterObject.field;
        this.getClientCare.matchCase = state.action.currentFilterObject.matchCase;
        this.getClientCare.operator = state.action.currentFilterObject.operator;
        this.getClientCare.value = state.action.currentFilterObject.value;
      } else {
        if (val == "filtering" && state.action.action == "clearFilter") {
          this.getClientCare.field = "CaseManagerName";
          this.getClientCare.matchCase = false;
          this.getClientCare.operator = "contains";
          this.getClientCare.value = "";
          this.getClientCare.type = "string";
          this.getClientCare.clientId = this.global.clientId;
        }
      }
      
      this.getclientCareLst();
    }
  
    //......................................deleteCeare.....................................
    deleteCeare() {
      let params = new URLSearchParams();
      params.append("Id", this.deletecareId.toString());
      let url =
        "api/ReferralCareCoordinatorRelationship/DeleteReferralCoordinatorRelationship?";
      this.CommonAPI.DeleteFunctionForDeleteHttp(params, url)
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(
          (data: any) => {
            this.toastrService.success(
              "Client Care Coordinator deleted successfully!"
            );
            document.getElementById("deletecarecoordinator").click();
            setTimeout(() => {
              this.toastrService.clear();
            }, 8000);
            // this.getClientcasemanagerandContactDetails();
            this.getclientCareLst();
          },
          (err: any) => {
            this.toastrService.error(err, "error");
            setTimeout(() => {
              this.toastrService.clear();
            }, 8000);
          }
        );
    }
  
    //......................................getclientCareLst.....................................
    getclientCareLst() {
      this.getClientCare.clientId = this.global.clientId;
      this.getClientCare.referralId = this.global.referralId;
      this.getClientCare.statusLid = (this.CareStatus != 0) ? (this.CareStatus?.toString()) : null;
      this.CCESCare.outputValuesCareCoordinator(this.getClientCare);
      this.datacare.pipe(takeUntil(this.onDestroy$)).subscribe(
        (data: any) => {
          this.carecoLst = data.result;
  
          this.carecoLst.forEach((c) => {
            c.fax != null
              ? this.general.reconverPhoneGoogleLibhttpsave(c.fax)
              : null;
            c.alternateFax != null
              ? this.general.reconverPhoneGoogleLibhttpsave(c.alternateFax)
              : null;
            c.phoneNumber != null
              ? this.general.reconverPhoneGoogleLibhttpsave(c.phoneNumber)
              : null;
          });
        },
        (err: any) => {
          this.toastrService.error(err);
        }
      );
    }
  
  
  
    //......................................evenfromcare.....................................
    evenfromcare(event) {
      this.saveclientcare.careCoordinatorId = event;
      this.saveclientcare.clientId = this.global.clientId;
      let url =
        "api/ReferralCareCoordinatorRelationship/SaveReferralCoordinatorRelationship";
      this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(this.saveclientcare, url)
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(
          (data: any) => {
            this.careenable = false;
            document.getElementById("Careopen").click();
            this.getclientCareLst();
            // this.getClientcasemanagerandContactDetails();
          },
          (err: any) => {
            this.toastrService.error(err, "error");
            setTimeout(() => {
              this.toastrService.clear();
            }, 8000);
          }
        );
    }
     //......................................getCareCoordinatordropdown.....................................
      getCareCoordinatordropdown() {
        this.assignCare = new AssignCareCoordinator();
        let url = "api/ClientCareCoordinator/getCareCoordinatordropdown?";
        this.CommonAPI.GetFunctionwithResponseTypeJson("", url)
          .pipe(takeUntil(this.onDestroy$))
          .subscribe(
            (data: any) => {
              this.CareCoordinatorDropdownList = data;
              this.CareCoordinatorDropdownList.forEach(element => {
                element.Key = element.Key?.toString();
                element.Value = element.Value?.toString();
              });
    
            },
            (err: any) => {
              this.toastrService.error(err);
            }
          );
      }
  //......................................getClientcasemanagerandContactDetails.....................................
  getClientcasemanagerandContactDetails() {
    let myparams = new URLSearchParams();
    myparams.append("clientId", this.global.clientId.toString());
    let url = "api/Client/getClientSummary?";
    this.CommonAPI.GetFunctionwithResponseTypeJson(myparams, url).subscribe(
      (data) => {
        this.clientcasemanagerandContactDetail = data;
        this.clientcasemanagerandContactDetail?.caseManagers?.map(
          (t) => (t.phone = this.general.converPhoneGoogleLib(t.phone))
        );

        this.clientcasemanagerandContactDetail?.caseManagers?.map(
          (t) => (t.fax = this.general.converPhoneGoogleLib(t.fax))
        );
        this.clientcasemanagerandContactDetail?.caseManagers?.map(
          (t) =>
            (t.alternateFax = this.general.converPhoneGoogleLib(t.alternateFax))
        );
        this.clientcasemanagerandContactDetail?.emergencyContacts?.map(
          (p) =>
            (p.phoneNumber = this.general.converPhoneGoogleLib(p.phoneNumber))
        );
        this.clientcasemanagerandContactDetail?.responsiblePartyContacts?.map(
          (p) =>
            (p.phoneNumber = this.general.converPhoneGoogleLib(p.phoneNumber))
        );
        this.clientcasemanagerandContactDetail?.careCoordinators.map(
          (CC) =>
            (CC.phoneNumber = this.general.converPhoneGoogleLib(CC.phoneNumber))
        );

        this.clientcasemanagerandContactDetail?.careCoordinators.map(
          (CC) =>
          (CC.alternateFax = this.general.converPhoneGoogleLib(
            CC.alternateFax
          ))
        );

        this.clientcasemanagerandContactDetail?.careCoordinators.map(
          (CC) => (CC.fax = this.general.converPhoneGoogleLib(CC.fax))
        );
        this.clientcasemanagerandContactDetail?.caseManagers?.map(
          (t) => (t.activeDate = this.datepipe.transform(t?.activeDate, "MM/dd/yyyy"))
        );
        this.clientcasemanagerandContactDetail?.careCoordinators?.map(
          (t) => (t.activeDate = this.datepipe.transform(t?.activeDate, "MM/dd/yyyy"))
        );

        this.clientcasemanagerandContactDetail?.employeeClientMappings?.map(
          (t) => (t.activeDate = this.datepipe.transform(t?.activeDate, "MM/dd/yyyy"))
        );

        this.clientcasemanagerandContactDetail?.qps?.forEach((a) => {
          a.address =
            (a.street != null ? a.street : "") +
            " " +
            (a.apt != null ? a.apt : "") +
            " " +
            (a.city != null ? a.city : "") +
            " " +
            (a.steet != null ? a.steet : "") +
            " " +
            (a.zipcode != null ? a.zipcode : "");
        });        
      },
      (err) => { }
    );

  }
  public onActionCompleteCare(args) {
    this.getClientCare.currentpageno =
      this.gridcarecoordinator.pagerModule.pagerObj.currentPage;
    this.getClientCare.pageitem =
      this.gridcarecoordinator.pagerModule.pagerObj.pageSize;
    if (args.name == "actionBegin" && args.requestType == "filterbeforeopen") {
      this.getClientCare.type = args.columnType;
    }
  }
   clearGridLocalStorage(): void {
    // Define grid configurations for visits
    const gridConfigs = [
      { localStorageKey: 'gridreferralGrid', expectedColumns: this.ReferralTotalColumns },
    ];
    
    // Use global method for localStorage clearing
    this.global.clearGridIdLocalStorage(gridConfigs);
  }
  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }
  isApplyFilterDisabled(): boolean {
  // Get the selected status name
  const selectedStatus = this.statusList?.find(s => s.id === this.RBO.ReferralStatusLid);
  const statusName = selectedStatus?.lovName?.toUpperCase();
  
  // If "UNDER 24 hrs" is selected
  if (this.referralAge === 'UNDER') {
    return false; // Enable the button
  }
  
  // If "OVER 24 hrs" is selected
  if (this.referralAge === 'OVER') {
    // If status is NOT "Pending", dates are mandatory
    if (statusName !== 'PENDING') {
      return !this.referralstartDate || !this.referralendDate;
    }
    // If status IS "Pending", dates are not mandatory
    else {
      return false; // Enable the button
    }
  }
  
  return false;
}
// Show asterisk when Apply button would be disabled due to missing dates
shouldShowDateAsterisk(): boolean {
  const selectedStatus = this.statusList?.find(s => s.id === this.RBO.ReferralStatusLid);
  const statusName = selectedStatus?.lovName?.toUpperCase();
  
  return this.referralAge === 'OVER' && statusName !== 'PENDING';
}
}
